import { clsx } from 'clsx';
import * as styles from './styles.css';
import { ArticleHeading3, ArticleParagraph1, Button, useDeviceType } from '@cian/ui-kit';

interface IQuizResultProps {
  title: string;
  text: string;
  image: string;
  isLoading: boolean;
  onBtn: VoidFunction;
}

export const QuizResult: React.FC<IQuizResultProps> = ({ title, text, image, isLoading, onBtn }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={clsx(styles['image'], styles[image])} />
      <ArticleHeading3>{title}</ArticleHeading3>
      <ArticleParagraph1 textAlign="center">{text}</ArticleParagraph1>
      <div className={styles['btn']}>
        <Button fullWidth loading={isLoading} onClick={onBtn}>
          Отлично!
        </Button>
      </div>
    </div>
  );
};
